import * as React from "react";

const ProductListingsOrmD: React.FC = () => {
    return (
        <svg
            width="20px"
            height="20px"
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g fill="none" fillRule="evenodd" transform="translate(1 1)">
                <path
                    stroke="currentColor"
                    strokeWidth="1.5"
                    d="M14.5368003,3.37280028 L14.5368003,14.5368003 L3.37280028,14.5368003 L3.37280028,3.37280028 L14.5368003,3.37280028 Z"
                    transform="rotate(45 8.955 8.955)"
                />
                <polygon fill="currentColor" points="9 2 12.5 5.5 5.5 5.5" />
                <polygon fill="currentColor" points="9 12.41 12.5 15.91 5.5 15.91" transform="rotate(-180 9 14.16)" />
            </g>
        </svg>
    );
};

export default React.memo(ProductListingsOrmD);
